import i18n from '@/i18n';
import { fixedUi } from '@/i18n/fixedUi';
import { normalizeTiktokShopType } from '@/tiktok-platform/constants/tiktokRoutes';

const LOCAL_FALLBACK = {
  headline: '对接 TikTok 本土店后，本地发品与订单更顺一截',
  lead: '把产品发布、合规资料、订单售后与经营数据收进同一工作区——本土发品不绑站点·仓·运费，平台按本土物流计费。',
  highlights: [
    ['发品链路齐全', '发布产品、产品信息、发布记录与草稿箱同壳管理，状态可追踪。'],
    ['模板与合规就位', '产品模板、尺码库、属性库、品牌库与合规资料可复用；本土不展示发货仓库与运费模板。'],
    ['订单与经营可同步', '订单列表、退货退款、取消单、营销活动、经营数据与财务账单按授权店铺拉取。'],
    ['店铺类型强隔离', '工作区 Session 绑定「本土」；与跨境、以及 SHEIN / TEMU 工作区互不串台，跨类型需回门禁重验。'],
  ],
};

const FULL_FALLBACK = {
  headline: '对接 TikTok 全托管后，供货与经营收进同一工作区',
  lead: '全托管走 Global Selling 独立应用。发品不绑站点、仓和运费，订单、经营数据与财务按该类型店铺隔离。',
  highlights: [
    ['独立应用授权', '全托管使用单独的 App Key / Service ID，不能和跨境、本土应用混用。'],
    ['发品按全托口径', '跳过发货仓库与运费模板，套用发品时也不提交这些字段。'],
    ['经营数据可同步', '订单、营销、经营数据与财务账单按当前全托管店铺拉取。'],
    ['店铺类型强隔离', '工作区 Session 绑定「全托管」；与跨境、本土以及 SHEIN / TEMU 工作区互不串台。'],
  ],
};

const CROSS_FALLBACK = {
  headline: '对接 TikTok 跨境店后，发品与运营更顺一截',
  lead: '把产品发布、模板库、合规、订单与财务收进同一工作区——跨境发品可选用发货仓库与运费模板，少切换工具。',
  highlights: [
    ['设计到上架不断层', 'IPE 产出可衔接 TikTok 发品：发布产品、产品信息、发布记录与草稿箱同一工作流。'],
    ['模板与仓运费齐备', '产品模板、尺码/属性/品牌库，以及发货仓库、运费模板，服务跨境 Create Product 必填项。'],
    ['运营模块可同步', '合规资料、营销活动、订单/售后、经营数据与财务账单按当前授权店铺本地缓存与同步。'],
    ['店铺类型强隔离', '工作区 Session 绑定「跨境」；不可操作本土能力，亦与 SHEIN / TEMU 工作区完全分离。'],
  ],
};

function story(branch, fallback) {
  const text = (key, zh) => fixedUi(
    i18n.t(`tiktokGate.${branch}.${key}`, { ns: 'workbench', defaultValue: zh }),
  );
  return {
    headline: text('headline', fallback.headline),
    lead: text('lead', fallback.lead),
    highlights: fallback.highlights.map(([title, desc], index) => ({
      title: text(`h${index + 1}Title`, title),
      desc: text(`h${index + 1}Desc`, desc),
    })),
  };
}

/**
 * TikTok 门禁左侧叙事文案（随店铺类型切换）。
 * 口径与侧栏一致：跨境 / 本土 / 全托管。
 */
export function gateCopyForTiktokShopType(shopType) {
  const type = normalizeTiktokShopType(shopType);
  if (type === '本土') return story('local', LOCAL_FALLBACK);
  if (type === '全托管') return story('full', FULL_FALLBACK);
  return story('cross', CROSS_FALLBACK);
}
